import "../../modal.scss";
import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import { Datatable } from "../departamentosTable/Datatable";
import { DepartamentosState } from "../../../context/departamentos/DepartamentosState";

Modal.setAppElement("#root"); // Necesario para accesibilidad

const DepartamentosModal = ({ handleChange,handleDescChange,idSelectorProv,descSelected,handleLocChange }) => {
  const name ="Departamento";
const [searchIdItem, setSearchIdItem] = useState(null);
  const [searchDescItem, setSearchDescItem] = useState("");
  const searchInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Sincronizar descSelected inicial con el estado
  useEffect(() => {
    if (descSelected && searchDescItem !== descSelected) {
      setSearchIdItem(0);
      setSearchDescItem(descSelected);
    } else if (!descSelected && searchDescItem !== "") {
      setSearchDescItem("");
    }
  }, [descSelected]);

  const handleRowClick = (selectedId, selectedDesc) => {
    setSearchIdItem(selectedId);
    setSearchDescItem(selectedDesc);
    handleChange(selectedId);
    handleDescChange(selectedDesc);
    setIsModalOpen(false);
  };

  const handleClear = () => {
    setSearchIdItem(null);
    setSearchDescItem("");
    handleChange(null);
    handleLocChange&&handleLocChange(null);
    handleDescChange("");
    if (searchInputRef.current) {
      searchInputRef.current.value = `Buscar ${name}`;
    }
  };

  return (
    <>
      <div className="inputWrapper">
        <input
          type="text"
          value={searchDescItem || "Buscar " + name}
          readOnly
          ref={searchInputRef}
        />
        {!searchIdItem && !searchDescItem && (
          <button
            className="SearchButton"
            onClick={(e) => {
              e.preventDefault();
              setIsModalOpen(true);
            }}
          >
            🔍
          </button>
        )}
        {(searchIdItem || searchDescItem) && (
          <button
            className="clearButton"
            onClick={(e) => {
              e.preventDefault();
              handleClear();
            }}
          >
            ❌
          </button>
        )}
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Seleccionar"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="data-grid-container">
          <div
            className="datatable"
            style={{
              height: "100%",
              maxHeight: "calc(80vh - 60px)",
              overflowY: "auto",
            }}
          >
            <DepartamentosState>
              <Datatable
                onSelect={handleRowClick}
                onClose={() => setIsModalOpen(false)}
                idSelectorProv={idSelectorProv}
                 enableCreate={true}
              />
            </DepartamentosState>
          </div>
        </div>
        <button
          className="modalCloseButton"
          onClick={() => setIsModalOpen(false)}
        >
          ❌
        </button>
      </Modal>
    </>
  );
};

export default DepartamentosModal;
